export default class TimeStr {
  static readableTime(timeStr: string) {
    if (timeStr.length !== 4) return '';
    return `${timeStr.substring(0, 2)}:${timeStr.substring(2, 4)}`;
  }

  static getContentDateTime(t: string | Date) {
    const time = t instanceof Date ? t : new Date(t);
    const now = new Date();
    const diffInMs = now.getTime() - time.getTime();

    // 1) If no earlier than 60 seconds
    if (diffInMs < 60 * 1000) {
      return '지금';
    }
    // 2) If no earlier than 60 minutes
    else if (diffInMs < 60 * 60 * 1000) {
      return `${Math.floor(diffInMs / (60 * 1000))}분 전`;
    }
    // 3) If today, use getReadableTime with medium detail
    else if (now.toDateString() === time.toDateString()) {
      return this.getReadableTime(time, ':', 'medium');
    } else {
      const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
      // 4) If within the past year, use getReadableDate with medium detail
      if (time > oneYearAgo) {
        return this.getReadableDateTime(time, '-:', 'medium');
      }
      // 5) If older than one year, use getReadableDate with high detail
      else {
        return this.getReadableDate(time, '-', 'high');
      }
    }
  }

  static getReadableDate(
    date: Date,
    pattern: '-' = '-',
    detail: 'high' | 'semi-high' | 'medium' = 'medium',
  ) {
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-11, so +1 to make it 1-12
    const day = date.getDate().toString().padStart(2, '0');

    if (pattern === '-') {
      let formattedDate = '';
      if (detail === 'high') {
        formattedDate = `${year}-${month}-${day}`;
      } else if (detail === 'semi-high') {
        formattedDate = `${year.substring(2)}-${month}-${day}`;
      } else if (detail === 'medium') {
        formattedDate = `${month}-${day}`;
      }
      return formattedDate;
    }

    return '';
  }

  static getReadableTime(date: Date, pattern: ':' = ':', detail: 'high' | 'medium' = 'medium') {
    const hour = date.getHours().toString().padStart(2, '0');
    const minute = date.getMinutes().toString().padStart(2, '0');
    const second = date.getSeconds().toString().padStart(2, '0');

    if (pattern === ':') {
      let formattedDate = '';
      if (detail === 'high') {
        formattedDate = `${hour}:${minute}:${second}`;
      } else if (detail === 'medium') {
        formattedDate = `${hour}:${minute}`;
      }
      return formattedDate;
    }

    return '';
  }

  static getReadableDateTime(date: Date, pattern: '-:', detail: 'high' | 'medium' = 'medium') {
    const readableDate = this.getReadableDate(date, '-', detail);
    const readableTime = this.getReadableTime(date, ':', detail);
    const formattedDateTime = `${readableDate} ${readableTime}`;
    return formattedDateTime;
  }

  static formatTz(d: Date, timeZone: string, withSeconds = false) {
    const f = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: withSeconds ? '2-digit' : undefined,
      hourCycle: 'h23',
    });
    const parts = Object.fromEntries(f.formatToParts(d).map((p) => [p.type, p.value]));
    const date = `${parts.year}-${parts.month}-${parts.day}`;
    const time = withSeconds
      ? `${parts.hour}:${parts.minute}:${parts.second}`
      : `${parts.hour}:${parts.minute}`;
    return `${date} ${time}`.trim();
  }
}
